import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Alert } from '@mui/material';
import { DocusealForm } from '@docuseal/react';
import { useMemo } from 'react';
import { toast } from 'react-toastify';

interface ApproveApplicationDialogProps {
    open: boolean;
    onClose: () => void;
    application: any | null;
    generating: boolean;
}

const ApproveApplicationDialog = ({ open, onClose, application, generating }: ApproveApplicationDialogProps) => {
    const docusealSlug = application?.docusealSubmission?.data?.[0]?.slug;

    const employeeName = useMemo(() => {
        if (!application?.employee) {
            return '';
        }
        return `${application.employee.firstName ?? ''} ${application.employee.surname ?? ''}`.trim();
    }, [application]);

    const benefitName = application?.benefit?.name ?? 'this benefit';

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>Approve {benefitName}</DialogTitle>
            <DialogContent dividers>
                {generating || !docusealSlug ? (
                    <Box sx={{ height: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Alert severity="info">
                            We&apos;re preparing the contract for this application. This should only take a moment…
                        </Alert>
                    </Box>
                ) : (
                    <Box sx={{ height: '70vh' }}>
                        <Alert severity="info" sx={{ mb: 2 }}>
                            Please review and sign the contract below to approve {employeeName ? `${employeeName}'s` : 'this'} application.
                            The application will update automatically once the signature is complete.
                        </Alert>
                        <DocusealForm
                            src={`https://docuseal.co/d/${docusealSlug}`}
                            email={application?.company?.primaryContactEmail || application?.company?.hrContacts?.[0]?.email || ''}
                            onComplete={() => {
                                toast.success('The contract was signed successfully.');
                                onClose();
                            }}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                        />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="secondary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ApproveApplicationDialog;

